export type MetricName =
  | "jmap.latency_ms"
  | "jmap.error"
  | "ws.state"
  | "ws.reconnect"
  | "render.failure"
  | "render.duration_ms"
  | "attachment.fetch_ms"
  | "sync.status";

export type MetricEntry = {
  name: MetricName;
  value: number;
  at: number;
  tags?: Record<string, string>;
};

const MAX_ENTRIES = 120;
const buffer: MetricEntry[] = [];

/** Local-only metrics ring buffer — no external telemetry. */
export function recordMetric(
  name: MetricName,
  value: number,
  tags?: Record<string, string>,
): void {
  buffer.push({ name, value, at: Date.now(), tags });
  if (buffer.length > MAX_ENTRIES) buffer.shift();
  if (process.env.NODE_ENV === "development" && name.endsWith(".error")) {
    console.debug("[originmail:metric]", name, value, tags);
  }
}

export function recordEvent(name: MetricName, tags?: Record<string, string>): void {
  recordMetric(name, 1, tags);
}

export function getRecentMetrics(limit = 40): MetricEntry[] {
  return buffer.slice(-limit);
}

export function getMetricSummary(name: MetricName): { count: number; avg: number; last: number | null } {
  const rows = buffer.filter((m) => m.name === name);
  if (!rows.length) return { count: 0, avg: 0, last: null };
  const sum = rows.reduce((a, r) => a + r.value, 0);
  return { count: rows.length, avg: sum / rows.length, last: rows[rows.length - 1]?.value ?? null };
}
